import { Card, CardActionArea, CardMedia } from '@prisjakt/ui/card';
import { layout } from 'src/components/base';
import styled from 'styled-components';
import { TitleSmallText } from '@prisjakt/ui/text/variants';

export const StyledCard = styled(Card)`
  height: 100%;
`;

export const StyledCardMedia = styled(CardMedia)`
  margin-right: ${layout.measurements.spacing075};
  align-self: center;
  max-width: 72px;

  border-bottom-right-radius: ${layout.measurements.spacing050} !important;
  border-top-right-radius: ${layout.measurements.spacing050} !important;
`;

export const StyledContent = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: space-between;
  align-self: center;
`;

export const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledMenu = styled.div`
  position: absolute;
  top: ${layout.measurements.spacing075};
  right: ${layout.measurements.spacing075};
`;

export const StyledTitle = styled(TitleSmallText)`
  max-width: calc(100% - 40px);
`;

export const StyledCardActionArea = styled(CardActionArea)`
  padding: ${layout.measurements.spacing075};
  width: 100%;
  height: 100%;
  align-items: center;
`;
